import { ga } from 'js/analytics/adapters'
export const trackForgotPassword = () => {
  ga.track('click_forgot_password')
}
